define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/constants',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Util, Constants, Component) => {

  const { classNames } = Util;

  /**
   * Returns a class name for the given column layouts
   */
  function getClassNameForLayouts (layouts) {
    let className = [];
    layouts.forEach((span, size) => {
      className.push(`sumome-gridColumn-${size}-${span}`);
    });
    return className.join(' ');
  }

  @Component()
  class GridRow extends React.Component {
    static propTypes = {
      childComponents: PropTypes.object,
    };

    static defaultProps = {
      style: Immutable.Map(),
    };

    renderColumns() {
      const {
        childComponents,
        onMouseEnterComponent,
        onMouseLeaveComponent,
        renderComponent,
      } = this.props;

      return childComponents.map((childComponent, key) => {
        const layouts = childComponent.get('layouts');
        const className = getClassNameForLayouts(layouts);
        return renderComponent(childComponent, { className });
      });
    }

    render() {
      const gridRowStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
      };

      return (
        <div
          className='sumome-wysiwyg-gridRow-contents'
          style={gridRowStyle}
          ref={(el) => this.textEl = el}
        >
          {this.renderColumns()}
        </div>
      );
    }
  }

  return GridRow;
});
